(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_custom_accordian"] && !Shopify.designMode) return;
  try {
    const accordianHeadings = document.querySelectorAll('.accordian-heading');
  const accordianContents = document.querySelectorAll('.accordian-content');
  const accordianArrows = document.querySelectorAll('.accordian-arrow');

  accordianHeadings.forEach((element, index) => {
    element.addEventListener('click', () => {
      const clickIndex = index;

      const computedStyles = window.getComputedStyle(accordianContents[clickIndex]);

      if (computedStyles.display == 'block') {
        accordianContents[clickIndex].style.display = 'none';
        accordianArrows[clickIndex].style.transform = 'rotate(0deg)';
      } else {
        accordianContents[clickIndex].style.display = 'block';
        accordianArrows[clickIndex].style.transform = 'rotate(180deg)';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_custom_offers"] && !Shopify.designMode) return;
  try {
    const codes = document.querySelectorAll(".code");
  const copyCodeCtas = document.querySelectorAll(".copy-code");

  copyCodeCtas.forEach((element, index) => {
    element.addEventListener("click", ()=>{
      const clickIndex = index
      navigator.clipboard.writeText(codes[clickIndex].textContent);

      alert("Copied the code " + codes[clickIndex].textContent);
    })
  });
  } catch(e) { console.error(e); }
})();

})();
